// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-Sq8_","delete":"styles_delete__1fTEx","update":"styles_update__YDr_o","add":"styles_add__pfW64"};